import React, {CSSProperties, useCallback} from 'react';

import {CheckIcon} from '../../svg-icon';
import {cls} from '../../../utils';

import css from './check-circle.module.css';

type Props = {
	selected?: boolean;
	onSelect: (selected: boolean) => void;
	style?: CSSProperties;
	className?: string;
};

export const CheckCircle: React.FC<Props> = ({selected, onSelect, style, className}) => {
	const handleClick = useCallback(
		(event: React.MouseEvent) => {
			event.stopPropagation();
			onSelect(!selected);
		},
		[selected, onSelect],
	);
	return (
		<div>
			<div
				onClick={handleClick}
				className={cls(css.wrapper, selected && css.selected, className)}
				style={style}
				role="checkbox"
				aria-checked={selected ? 'true' : 'false'}
			>
				<CheckIcon width={10} height={10} />
			</div>
		</div>
	);
};
